export default {
    // hostUrl: 'https://tmp.tw51buygobuy.com',//本地验证使用
    // 服务器地址
    hostUrl: process.env.API_ROOT || window.location.origin,
    // 图片的cdn地址，仅用于接口上传
    cdnUrl: 'https://d1q4aqp7bomo9e.cloudfront.net/Public',
    // 客服地址
    //msgUrl: 'https://www.facebook.com/messages/t/113690220462833',
    msgUrl: 'https://m.me/113690220462833?ref=' + encodeURIComponent(location.href),
    // msgUrl: 'https://m.me/103018364497776?ref=' + encodeURIComponent(location.href),
    // 初始加载图
    loading: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAANSURBVBhXYzh8+PB/AAffA0nNPuCLAAAAAElFTkSuQmCC'
}



// WEBPACK FOOTER //
// ./src/util/config.js